export type ActorTag = "tower" | "trailer" | "chaser" | "mine" | "projectile";
export class TagTrait implements ex.IActorTrait {
    public readonly tag: ActorTag;
    constructor(tag: ActorTag) {
        this.tag = tag;
    }
    public update(actor: ex.Actor, engine: ex.Engine, delta: number) {
    }
}
